// LICENSE_CODE ZON
'use strict';

/*jslint browser:true, es6:true, node:true, react:true*/
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useContext } from 'react';
import cn from 'classnames';
import { useLocation } from 'react-router-dom';
import { App_context } from '../../context.js';
import { Links_nav } from './links_nav.js';
import user_agent from '/util/user_agent.js';
var Menu_nav = props => {
  var _useContext = useContext(App_context),
    is_plus = _useContext.is_plus,
    is_ultra = _useContext.is_ultra;
  var browser = user_agent.guess_browser();
  if (browser.opera) browser.browser = 'opera';
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  var sites_cls = cn('nav-tab', ['/', '/sites'].includes(pathname) && 'nav-tab-active');
  var plus_cls = cn('nav-tab nav-link', pathname.match(/^\/(premium|join|pricing)/) && 'nav-tab-active');
  var links = {
    sites: {
      to: '/sites',
      cls: sites_cls,
      text: 'Sites'
    },
    products: {
      to: '/products',
      text: 'Products'
    },
    plus: {
      cls: plus_cls,
      to: '/pricing?ref=navbar',
      text: 'Plans',
      show: !props.is_plus && !is_plus || !props.is_ultra && !is_ultra
    }
  };
  return /*#__PURE__*/React.createElement(Links_nav, _extends({}, props, {
    links: links
  }));
};
export { Menu_nav };